import React from 'react';

import { Partner } from 'src/reducers/partner/types';

import i18n from 'Utilities/i18n';

type Props = {
  partner: Partner;
};

const getSharingKey = (partner: Partner): string => {
  switch (partner.type) {
    case 'insulet':
      return 'Partners.insuletStopReceiving';
    case 'fhir':
      return 'Partners.toStopSharingData';
    default:
      return 'PartnersGeneric.stopSharingInstructions';
  }
};

const StopSharing: React.FC<React.PropsWithChildren<Props>> = ({ partner }) => {
  return (
    <span id="stop-sharing-text" className="text-black-50 text-md d-block">
      {i18n.t(getSharingKey(partner), {
        partner: partner.name,
        partnerName: partner.name,
      })}
    </span>
  );
};

export default StopSharing;
